export class AppConstConfig {
  static SESSION_USER_TOKEN = 'access_token'
  static URL_REGEX =
    // eslint-disable-next-line no-useless-escape
    /\b((?:https?|ftp):\/\/|www\.)[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&//=]*)\b/
  static APP_DEFAULT_CURRENCY = '€'
}
